import { render, staticRenderFns } from "./icon-lock.vue?vue&type=template&id=9824c1a8&"
import script from "./icon-lock.vue?vue&type=script&lang=js&"
export * from "./icon-lock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports